import React from "react";
import legalDocumentStyles from "../LegalDocuments.module.css";
import Wrapper from "../../UI/Wrapper/Wrapper";

const TermsOfService = () => (
  <Wrapper>
    <div className={legalDocumentStyles.LegalDocuments}>
      <h1>OPŠTI USLOVI KORIŠĆENJA PLATFORME APOTEKA.RS</h1>
      <div>
        <ol type="I">
          <li className={legalDocumentStyles.Headers}>KO SMO MI</li>
          <ol type="1">
            <li>
              <p>
                Mi smo Extra Care Group d.o.o. Beograd – Zemun, privredno
                društvo registrovano u Agenciji za privredne registre sa
                sedištem na adresi Dobanovačka 2, matični broj: 20990376, PIB:
                108392380 (u daljem tekstu: Extra Care Group ili Mi). Extra
                Care Group je razvio platformu Apoteka.rs kao informativni i
                komunikacioni servis.
              </p>
            </li>
          </ol>
          <li className={legalDocumentStyles.Headers}>PREDMET OPŠTIH USLOVA</li>
          <ol type="1">
            <li>
              <p>
                Ovim Opštim uslovima utvrđuju se uslovi pristupa i korišćenja
                softvera Platforme Apoteka.rs (web i mobilne aplikacije).
                Korišćenjem naše Platforme pristajete na ove Opšte uslove.
              </p>
            </li>
          </ol>
          <li className={legalDocumentStyles.Headers}>DEFINICIJE</li>
          <ol type="1">
            <li>
              <ul>
                <li>
                  <p>
                    <strong>"Platforma"</strong> predstavlja zajednički naziv
                    za našu Android i iOS aplikaciju Apoteka.rs i web
                    aplikaciju https://apoteka.rs;
                  </p>
                </li>
                <li>
                  <p>
                    <strong>"Digitalne usluge"</strong> su napredni servisi
                    Platforme (on-demand konsultacije, AI podrška, prioritetna
                    komunikacija);
                  </p>
                </li>
                <li>
                  <p>
                    <strong>"Partneri"</strong> su apoteke i zdravstveni
                    profesionalci koji koriste Platformu za komunikaciju sa
                    korisnicima u okviru svoje registrovane delatnosti;
                  </p>
                </li>
                <li>
                  <p>
                    <strong>"Korisnici"</strong> su lica koja koriste Usluge
                    Platforme.
                  </p>
                </li>
              </ul>
            </li>
          </ol>
          <li className={legalDocumentStyles.Headers}>
            ULOGA PLATFORME I POSLOVNI MODEL (SaaS)
          </li>
          <ol type="1">
            <li>
              <p>
                Platforma Apoteka.rs je isključivo komunikacioni i informativni
                servis (SaaS – Software as a Service).
              </p>
            </li>
            <li>
              <p>
                Extra Care Group ne vrši prodaju lekova, dijetetskih
                suplemenata niti medicinskih sredstava, niti posreduje u
                njihovom prometu. Sav promet robe vrši se direktno između
                Korisnika i Partnera (apoteka), izvan sistema Platforme, u
                skladu sa važećim zakonskim propisima Republike Srbije.
              </p>
            </li>
            <li>
              <p>
                Extra Care Group ne naplaćuje robu niti usluge u ime Partnera.
                Naša uloga je isključivo pružanje tehnološke infrastrukture
                koja omogućava efikasnu komunikaciju i rezervaciju
                termina/proizvoda.
              </p>
            </li>
          </ol>
          <li className={legalDocumentStyles.Headers}>
            DIGITALNE USLUGE I MODELI PRETPLATE
          </li>
          <ol type="1">
            <li>
              <p>
                <strong>Model pretplate:</strong> Korisnici mogu pristupiti
                naprednim Digitalnim uslugama (konsultacije sa
                lekarima/farmaceutima, AI asistencija) kupovinom mesečnih
                pretplatničkih paketa. Extra Care Group je jedini pružalac
                ovih digitalnih usluga.
              </p>
            </li>
            <li>
              <p>
                <strong>Obračunske jedinice:</strong> Kupovinom pretplate,
                Korisnik dobija pravo na korišćenje određenog obima usluga
                izraženog kroz interne "obračunske jedinice" (kredite). Ove
                jedinice služe isključivo kao tehnička mera utroška resursa
                Platforme unutar tekućeg meseca, nemaju novčanu vrednost, ne
                mogu se unovčiti, niti preneti na treća lica.
              </p>
            </li>
            <li>
              <p>
                <strong>Zatvoreni sistem:</strong> Jedinice usluge su
                namenjene isključivo za potrošnju unutar zatvorenog sistema
                Platforme Apoteka.rs i ne predstavljaju elektronski novac
                (e-money) niti platni instrument.
              </p>
            </li>
          </ol>
          <li className={legalDocumentStyles.Headers}>
            TAČNOST I AŽURNOST PODATAKA
          </li>
          <ol type="1">
            <li>
              <p>
                S obzirom na to da Platforma služi kao komunikacioni kanal,
                Partneri su isključivo odgovorni za tačnost podataka o svom
                asortimanu i dostupnosti proizvoda. Extra Care Group ne
                odgovara za sadržaj podataka koje Partneri unose.
              </p>
            </li>
          </ol>
          <li className={legalDocumentStyles.Headers}>
            USLOVI KORIŠĆENJA ZA KORISNIKE
          </li>
          <ol type="1">
            <li>
              <p>
                Korišćenje osnovnih informacija o dostupnosti proizvoda je
                besplatno. Korišćenje naprednih Digitalnih usluga (on-demand
                konsultacije) podleže modelu pretplate. Registracijom korisnik
                potvrđuje da je stariji od 18 godina i da podatke koristi u
                skladu sa ovim uslovima.
              </p>
            </li>
          </ol>
          <li className={legalDocumentStyles.Headers}>REKLAMACIJA</li>
          <ol type="1">
            <li>
              <p>
                Platforma nije ugovorna strana u kupoprodaji proizvoda između
                Korisnika i Partnera. Sva odgovornost za kvalitet i isporuku
                proizvoda leži na Partneru. Reklamacije na Digitalne usluge
                koje pruža Extra Care Group mogu se uputiti na{" "}
                <a href="mailto:podrska@apoteka.rs">podrska@apoteka.rs</a>.
              </p>
            </li>
          </ol>
          <li className={legalDocumentStyles.Headers}>ZAVRŠNE ODREDBE</li>
          <ol type="1">
            <li>
              <p>
                Za sve što nije regulisano ovim Uslovima, primenjivaće se
                pravo Republike Srbije. Sporovi će se rešavati pred stvarno
                nadležnim sudom u Beogradu.
              </p>
            </li>
            <li>
              <p>Ažurirano: 26.04.2026. godine.</p>
            </li>
          </ol>
        </ol>
      </div>
    </div>
  </Wrapper>
);

export default TermsOfService;
